export const decodeJWTToken = (token: string | null) => {
  if (!token) return null;

  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      window
        .atob(base64)
        .split('')
        .map((c) => {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join('')
    );

    return JSON.parse(jsonPayload);
  } catch (e) {
    return null;
  }
};

export const isTokenExpired = (token: string | null, delta = 0) => {
  const tokenData = decodeJWTToken(token);

  if (!tokenData) return true;
  if (!tokenData.exp) return false;
  const currentTime = new Date().getTime() / 1000;

  return tokenData.exp < currentTime + delta;
};
